import { render, staticRenderFns } from "./emailValidation.vue?vue&type=template&id=bd78399e&"
import script from "./emailValidation.vue?vue&type=script&lang=js&"
export * from "./emailValidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports